var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1143 1L1 1.62854L1.94286 2.50856L2.50858 6.71999L5.46286 8.6057L5.58858 11.56H6.72L9.86286 14.1371L11.7486 13.6971L12.5029 15.8971L9.98857 19.6057L13.9486 25.9543L16.2114 26.6457L16.0857 71.0228L75.1086 70.96L76.3657 73.3485L72.6571 78.88L81.2057 78.9428L81.5829 77.8114L82.5886 76.7428L81.4571 74.7943L83.1543 74.4171L83.5943 71.2743L86.1714 68.76L87.24 69.8914L88.0571 69.1371L89 63.3543L88.2457 61.9086L86.36 62.6L83.8457 58.3257L84.9143 56.3143L84.0971 52.1657L79.5086 47.8914L77.8743 48.3943L78 46.8228L73.8514 43.8686L72.4057 40.6L75.9886 31.6114L71.84 29.3486L70.08 31.2343L68.6971 30.6686L67.6286 24.6343L59.4571 17.0286L57.5714 11.4971L57.32 6.90856L59.08 4.89713L57.32 4.83427L54.1143 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/MO.0b9ba211b348b302466c02dcaab10fc9.svg";
export { ForwardRef as ReactComponent };